import {
    VStack,
} from '@chakra-ui/react';
import { ComponentProps } from 'react';
import { AddressCard } from '@acp/core-ui';
import { useProperty } from '../hooks/use-property';

function PropertyAddressCard({
    propertyId,
    children,
    ...props
}: {
    propertyId: number;
} & ComponentProps<typeof VStack>) {
    const propertyQuery = useProperty(propertyId);

    return (
        <AddressCard
            address={propertyQuery.data?.address}
            isLoading={propertyQuery.isLoading}
            {...props}
        >
            {children}
        </AddressCard>
    );
}

export { PropertyAddressCard };
